import { cn } from '@/lib/utils';
import { OrganizationRegistrationStepDotProps } from './types';

const OrganizationRegistrationStepDot = (props: OrganizationRegistrationStepDotProps) => {
  const {
    isActive,
    isDone,
    label,
    number
  } = props;

  return (
    <div className="flex items-center gap-1">
      <span
        className={cn(
          'flex h-4 min-w-4 items-center justify-center rounded-full border px-1',
          'text-xs leading-4',
          isActive && 'border-accent bg-accent text-on-accent',
          isDone && !isActive && 'border-state-disabled-text text-state-disabled-text',
          !isActive && !isDone && 'border-state-disabled-text text-state-disabled-text'
        )}
      >
        {number}
      </span>
      <span
        className={cn(
          'text-xs leading-4',
          isActive ? 'text-foreground' : 'text-state-disabled-text'
        )}
      >
        {label}
      </span>
    </div>
  );
};

export default OrganizationRegistrationStepDot;